import {
  UpdateAliceCardProgramMutation,
  useMutationNotifier,
  useUpdateAliceCardProgramMutation,
} from '@alice-financial/alice-sdk'
import { UseGqlMutationCallbacks, useMutationOptionsWithInvalidation } from '@alice-financial/api'
import { useMutation } from '@tanstack/react-query'
import { useOrg } from '../../organization/useOrg'
import { useOrgId } from '../../useOrgId'

type UseSetUnifiedFundingMutationOptions = UseGqlMutationCallbacks<
  UpdateAliceCardProgramMutation,
  { hasUnifiedBanking: boolean }
>
export const useSetUnifiedFunding = (mutationOptions?: UseSetUnifiedFundingMutationOptions) => {
  const orgId = useOrgId()
  const { mutateAsync: updateAliceCardProgram } = useUpdateAliceCardProgramMutation()
  const mutationOptionsWithNotification = useMutationNotifier({}, mutationOptions)
  const mutateOptionsWithInvalidation = useMutationOptionsWithInvalidation(mutationOptionsWithNotification, [
    useOrg.getKey({ orgId }),
  ])
  return useMutation(
    ['setUnifiedBanking'],
    ({ hasUnifiedBanking }) => {
      if (!orgId) throw new Error('Must wait until org is loaded')
      return updateAliceCardProgram({ input: { orgId, hasUnifiedBanking } })
    },
    mutateOptionsWithInvalidation
  )
}
